import { render } from "./ViewArticleSidebar.vue?vue&type=template&id=75f9cf1e&ts=true"
import script from "./ViewArticleSidebar.vue?vue&type=script&lang=ts"
export * from "./ViewArticleSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__